import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2j8dggjwrm: FaireBrandEntity = {
  token: "b_2j8dggjwrm",
  type: "brand",
  name: "Silver Sparrow Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9521d15c64f614d0a4f852bdcd37465461965e91d5776d1fb2e1280abbd33b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5cce4a180b3a835f26f11774e9a5c55e192812a5cbf1f7f38e22f6d2215900e6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e9521d15c64f614d0a4f852bdcd37465461965e91d5776d1fb2e1280abbd33b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5cce4a180b3a835f26f11774e9a5c55e192812a5cbf1f7f38e22f6d2215900e6.png",
  location: "Colorado Springs, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 29,
  isInsider: true,
  description:
    "Silver Sparrow Jewelry is a vibrant jewelry design company committed to creating stylish and affordable pieces that embody the spirit of current trends and joyful expression. We take great pride in using high-quality materials, including semi-precious stones, sterling silver and gold-filled metals, and premium European metals. Our style is whimsical, and bohemian — designed for the free-spirtied woman. You can find unique, everyday necklaces, earrings and bracelets that are made to be worn like a personal totem or good luck charm throughout the day. Many of our collections are handmade in Colorado Springs, Colorado. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.165Z",
    importedBy: "entity-db-cli",
  },
};
